import { render, staticRenderFns } from "./FormsIcon.vue?vue&type=template&id=ea48de34&"
import script from "./FormsIcon.vue?vue&type=script&lang=js&"
export * from "./FormsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports